import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37ea04ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "计划日期", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_search_x" }, null, -1))
const _hoisted_6 = { class: "content_total" }
const _hoisted_7 = { class: "content_list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "content_list_item_top" }
const _hoisted_10 = { class: "content_list_item_top_left" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "content_list_item_top_left_tag"
}
const _hoisted_13 = {
  key: 2,
  class: "content_list_item_top_left_tagW"
}
const _hoisted_14 = { class: "content_list_item_top_right" }
const _hoisted_15 = {
  key: 0,
  class: "yellow"
}
const _hoisted_16 = {
  key: 1,
  class: "green"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 3,
  class: "purple"
}
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { key: 6 }
const _hoisted_22 = { class: "content_list_item_content" }
const _hoisted_23 = { class: "content_list_item_content_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "物料编码：", -1))
const _hoisted_25 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_26 = { class: "content_list_item_content_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划开工：", -1))
const _hoisted_28 = { class: "content_list_item_content_item_nr" }
const _hoisted_29 = { class: "content_list_item_content_item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产批次：", -1))
const _hoisted_31 = { class: "content_list_item_content_item_nr" }
const _hoisted_32 = { class: "content_list_item_content_item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划数量：", -1))
const _hoisted_34 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_35 = { class: "content_list_item_content_item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产设备：", -1))
const _hoisted_37 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_38 = {
  key: 0,
  class: "content_list_item_content_item"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "完工数量：", -1))
const _hoisted_40 = { class: "content_list_item_content_item_nr" }

import { reactive, ref, onMounted, onActivated } from "vue"
    import { useRouter, useRoute } from "vue-router"
    import { gsdate, judgmentPlatform } from '@/utils/utils'
    import { getList, pageCount } from '@/apis/WorkOrderAPI'
    import { model } from '@/interface'
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    interface form extends model {
        startDate: string,
        endDate: string,
        total: number,
        statusList: Array<any>
    }

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()
    const route = useRoute()

    // 搜索数据接口
    const form = reactive<form>({
        capacity: 10,
        page: 0,
        total: 0,
        startDate: '',
        endDate: '',
        mixParam: '',
        statusList: []
    })

    const minDate: Date = new Date(2021, 0, 1)

    const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

    let status = ref<boolean>(false)    // 根据平台是否需要设置top

    const openCode = ref<boolean>(false)

    const isOpenDate = ref(false);

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)

    // 搜索分类标签
    let tagList: any = ref([])

    // [
    //     {
    //         id: [0,1],
    //         name: '待生产',
    //         num: ''
    //     },
    //     {
    //         id: [2,3,7],
    //         name: '生产中',
    //         num: ''
    //     },
    //     {
    //         id: [4,5,6],
    //         name: '已完成',
    //         num: ''
    //     }
    // ]

    // 重置
    const reset = () => {
        form.startDate = ''
        form.endDate = ''
        form.mixParam = ''
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 搜索框
    const searchInput = (data: any) => {
        form.mixParam = data
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    const openDate = () => {
        isOpenDate.value = true
    }

    // 打开扫码组件
    const openScanCode = () => {
        openCode.value = true
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 确认选择日期
    const onConfirm = (values: any) => {
        const [start, end] = values
        form.startDate = gsdate(start)
        form.endDate = gsdate(end)
        isOpenDate.value = false
    };

    // 切换分类
    const clickTag = (id: any): void => {
        form.statusList = id
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        console.log(data)
    }

    // 跳转详情（报工前/报工后）
    const jump = (item: any) => {
        localStorage.setItem('workOder', JSON.stringify(item))
        router.go(-1)
    }

    // 获取工单列表数据
    const onLoad = () => {
        if (!finished.value) {
            loading.value = true;
            form.page = form.page + 1
            getList({
                capacity: form.capacity,
                page: form.page,
                model: {
                    mixParam: form.mixParam,
                    startDate: form.startDate,
                    endDate: form.endDate,
                    statusList: form.statusList.length === 0 ? tagList.value[0].id : form.statusList
                }
            }).then(res => {
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                loading.value = false;
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    form.total = res.data.total
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true;
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        onLoad();
    }

    // 查询工单分类数量
    const pageCounts = () => {
        pageCount({}).then(res => {
            if (res.code === 200) {
                tagList.value.forEach((item: any) => {
                    if (item.name == '待生产') {
                        item.num = String(res.data.startNum)
                    }
                    if (item.name == '生产中') {
                        item.num = String(res.data.ingNum)
                    }
                    if (item.name == '已完成') {
                        item.num = String(res.data.endNum)
                    }
                })
                // tagList.value[0].num = String(res.data.startNum)
                // tagList.value[1].num = String(res.data.ingNum)
                // tagList.value[2].num = String(res.data.endNum)
            }
        })
    }

    onMounted(() => {
        if (route.query.type == '1') {
            tagList.value = [
                {
                    id: [0,1],
                    name: '待生产',
                    num: ''
                },
                {
                    id: [2,3,7],
                    name: '生产中',
                    num: ''
                }
            ]
        } else {
            tagList.value = [
                {
                    id: [2,3,7],
                    name: '生产中',
                    num: ''
                }
            ]
        }
        status.value = judgmentPlatform()
        pageCounts()
    })

    onActivated(() => {
        form.page = 0
        finished.value = false
        list.value = []
        pageCounts()
        onLoad()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true,
        placeholder: "搜索工单编码/工序名称"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "Search_item_content",
              onClick: openDate
            }, [
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(form).startDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(form).startDate ? _unref(form).startDate : '开始日期'), 5),
              _hoisted_4,
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(form).endDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(form).endDate ? _unref(form).endDate : '结束日期'), 5)
            ])
          ])
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(vLableSelection, {
        TagList: _unref(tagList),
        isShow: true,
        onChange: clickTag
      }, null, 8, ["TagList"])
    ], 2),
    _createElementVNode("div", _hoisted_6, "共" + _toDisplayString(_unref(form).total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content_list_item",
                  key: i,
                  onClick: ($event: any) => (jump(item))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (item.mmodel)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.mmodel.name) + " | " + _toDisplayString(item.procedureName), 1))
                        : _createCommentVNode("", true),
                      (item.urgent)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "优先" + _toDisplayString(item.urgent), 1))
                        : _createCommentVNode("", true),
                      (item.paused === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "停"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (item.status === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "已创建"))
                        : _createCommentVNode("", true),
                      (item.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "已备料"))
                        : _createCommentVNode("", true),
                      (item.status === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "已完工"))
                        : _createCommentVNode("", true),
                      (item.status === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "已检验"))
                        : _createCommentVNode("", true),
                      (item.status === 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已报工"))
                        : _createCommentVNode("", true),
                      (item.status === 5)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "已入库"))
                        : _createCommentVNode("", true),
                      (item.status === 6)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, "已取消"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("span", null, "工单编码: " + _toDisplayString(item.code), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      (item.mmodel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(item.mmodel.code), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, _toDisplayString(item.planDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, _toDisplayString(item.batch), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      (item.umodel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(item.planNum) + _toDisplayString(item.umodel.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      (item.pgmodel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(item.pgmodel.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (item.status === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, _toDisplayString(item.proNum), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_8))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDate).value = $event)),
      type: "range",
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      color: "#4275FC",
      onConfirm: onConfirm
    }, null, 8, ["show", "min-date", "max-date"]),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['第一次扫码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"])
  ]))
}
}

})